import { Clock } from "lucide-react";
import { useI18n } from "../../lib/i18n";

/** Jam Jepang (JST) saat ini, apa pun zona waktu perangkat pembeli. */
export const jstHour = () => {
  const jst = new Date(Date.now() + (9 * 60 + new Date().getTimezoneOffset()) * 60000);
  return jst.getHours() + jst.getMinutes() / 60;
};

/** Kunci i18n + jam yang harus disisipkan untuk kondisi saat ini. */
export const deliveryNoticeKey = (zone, cutoffHour = 15, insideHour = 21) => {
  const inside = zone !== "outside";
  if (inside) return { key: "delivery_note_inside", hour: insideHour };
  return jstHour() < cutoffHour
    ? { key: "delivery_note_outside_today", hour: cutoffHour }
    : { key: "delivery_note_outside_tomorrow", hour: cutoffHour };
};

const pad = (h) => String(h).padStart(2, "0");

/** Pesan jadwal pengiriman sesuai zona pembeli dan jam pemesanan. */
export const DeliveryNotice = ({ fulfillment, zone, cutoffHour = 15, insideHour = 21 }) => {
  const { t } = useI18n();
  if (fulfillment !== "delivery") return null;

  const { key, hour } = deliveryNoticeKey(zone, cutoffHour, insideHour);
  const variant =
    key === "delivery_note_inside"
      ? "inside"
      : key === "delivery_note_outside_today"
        ? "same-day"
        : "next-day";
  const text = t(key).replace("{hour}", pad(hour));

  return (
    <div
      data-testid={`delivery-notice-${variant}`}
      className="flex gap-2 rounded-xl bg-primary/5 border border-primary/20 px-3 py-2.5 text-sm text-gray-700"
    >
      <Clock size={15} className="mt-0.5 shrink-0 text-primary" />
      <p className="leading-snug">{text}</p>
    </div>
  );
};
